module.exports = __webpack_public_path__ + "img/ai_icon.64881ae2.png";